<div class="button"  >
    <div class="content">{{name}}</div>
    <div class="bisel"></div>
  </div>